import React from "react";
import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { Button } from "../ui/button";

/**
 * Bouton "Réserver ce service" : renvoie vers la page de rendez-vous avec le
 * service présélectionné (/rendez-vous?service=<id>, voir bookableServices
 * dans src/data/servicesContent.js).
 */
const BookServiceButton = ({ serviceId, label = "Réserver ce service", className = "" }) => (
  <Button asChild className={className}>
    <Link to={`/rendez-vous?service=${serviceId}`}>
      <CalendarCheck className="w-4 h-4 mr-2" />
      {label}
    </Link>
  </Button>
);

export default BookServiceButton;
